export default function Debug() {
  return <>
    <div>{`Branch: ${process.env.REACT_APP_BRANCH_NAME}`}</div>
    <div>{`SHA: ${process.env.REACT_APP_SHA}`}</div>
    <div>{`BUILT: ${process.env.REACT_APP_BUILD_TIME}`}</div>
  </>
}